import { Component, Input } from '@angular/core';
import { ChatMessage } from '../model/search-message-dto';
import { TableModule } from 'primeng/table';
import { StatusConverterPipe } from '../../../../../common/pipes/status-converter.pipe';
import { OfferStatusPipe } from '../../../../../feature/offer/pipes/offer-status.pipe';
import { OrderStatusPipe } from '../../../../../feature/order/pipes/order-status.pipe';
import { DeliveryNoteStatusPipe } from '../../../../../feature/delivery-note/pipes/delivery-note-status.pipe';
import { InvoiceStatusPipe } from '../../../../../feature/invoice/pipes/invoice-status.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { ComponentBase } from '../../../../../common/component-base';
import { CurrencyPipe } from '@angular/common';
import { DocType } from '../../../../../common/enum/document-type.enum';
import { ContractStatusPipe } from '../../../../../feature/contract/pipes/contract-status.pipe';

import { LinkifyPipe } from '../../../../../common/pipes/linkify.pipe';

@Component({
  selector: 'gate-search-aggregate-result',
  standalone: true,
  imports: [TableModule, TranslatePipe, CurrencyPipe, LinkifyPipe],
  templateUrl: './search-aggregate-result.component.html',
  styleUrl: './search-aggregate-result.component.scss',
  providers: [StatusConverterPipe, OfferStatusPipe, OrderStatusPipe, DeliveryNoteStatusPipe, InvoiceStatusPipe, ContractStatusPipe],

})
export class SearchAggregateResultComponent  extends ComponentBase {
  @Input() public searchMessage!: ChatMessage;
  public get isAvailableDocumentNo(){
    return this.searchMessage.searchResultItems?.some(x => x.documentNo != null && x.documentNo != 'null' && x.documentNo != '');
  }
  public get isAvailableArticleNo(){
    return this.searchMessage.searchResultItems?.some(x => x.articleNo != null && x.articleNo != 'null' &&  x.articleNo != '');

  }
  public get isAvailableArticleDescription(){
    return this.searchMessage.searchResultItems?.some(x => x.articleDescription != null && x.articleDescription != 'null' && x.articleDescription != '');
  }
  public get isAvailableValueNet(){
   return this.searchMessage.searchResultItems?.some(x => x.valueNet != null);
  }
  public get isAvailableValueGross(){
   return this.searchMessage.searchResultItems?.some(x => x.valueGross != null);
  }

   /**
     * Method to get the document URL based on the document type and document number.
     * @param document - The document number.
     * @param documentType - The document type enum.
     * @returns The document URL.
     */
      openDocument(document: string, documentType: DocType) {
        if (document && documentType) {
          const documentNumber = document?.replace('/', '_');
          var url: string = '';
          if (documentType == DocType.Offer) url = `/offer/${documentNumber}`;
          else if (documentType == DocType.OrderConfirmation) url = `/order/${documentNumber}`;
          else if (documentType == DocType.DeliveryNote) url = `/delivery-note/${documentNumber}`;
          else if (documentType == DocType.Invoice) url = `/invoice/${documentNumber}`;
          if (url) this.navigateToNewTab(url);
        }
      }
}
